export const ALLOW_ILLEGAL_DATA =  "MedicalCopilot\\Forms\\AllowIllegalData";
export const USE_MILITARY_TIME =  "MedicalCopilot\\Formats\\UseMilitaryTime";
export const SESSIONTIMEOUT_ENABLED =  "MedicalCopilot\\SessionTimeout\\Enabled";
export const IDLESESSION_TIMEOUT =  "MedicalCopilot\\SessionTimeout\\IdleSessionTimeout";
export const IDLESESSION_TIMEOUTPROMPTTIME =  "MedicalCopilot\\SessionTimeout\\IdleSessionTimeoutPromptTime";